// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './AnnouncementsPage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function AnnouncementsPage() {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeCategory, setActiveCategory] = useState('All');

//   const categories = ['All', 'Admission', 'Results', 'Exam', 'Assignment', 'Event', 'Holiday', 'Notice', 'Academic'];

//   const announcementsData = [
//     {
//       id: 1,
//       title: 'Admissions Open for AY 2025–26 July Session – Apply Before September 30, 2025',
//       category: 'Admission',
//       date: 'July 15, 2025',
//       isUrgent: true,
//       dotColor: 'red'
//     },
//     {
//       id: 2,
//       title: 'April/May 2025 Examination Results Published on Official Portal',
//       category: 'Results',
//       date: 'July 10, 2025',
//       isUrgent: true,
//       dotColor: 'red'
//     },
//     {
//       id: 3,
//       title: 'Assignment Submission Last Date Extended to July 31, 2025',
//       category: 'Assignment',
//       date: 'July 5, 2025',
//       isUrgent: true,
//       dotColor: 'red'
//     },
//     {
//       id: 4,
//       title: 'University Offices Closed on July 19, 2025 – Regional Holiday',
//       category: 'Holiday',
//       date: 'June 28, 2025',
//       isUrgent: false,
//       dotColor: 'green'
//     },
//     {
//       id: 5,
//       title: 'Annual Convocation Ceremony Scheduled for August 10, 2025',
//       category: 'Event',
//       date: 'June 20, 2025',
//       isUrgent: false,
//       dotColor: 'green'
//     },
//     {
//       id: 6,
//       title: 'Hall Tickets for October 2025 Examinations Now Available',
//       category: 'Exam',
//       date: 'June 15, 2025',
//       isUrgent: false,
//       dotColor: 'purple'
//     },
//     {
//       id: 7,
//       title: 'Fee Payment Deadline for Current Semester – June 30, 2025',
//       category: 'Notice',
//       date: 'June 10, 2025',
//       isUrgent: false,
//       dotColor: 'yellow'
//     },
//     {
//       id: 8,
//       title: 'Special Admission Drive for Working Professionals – MBA 2025',
//       category: 'Admission',
//       date: 'June 5, 2025',
//       isUrgent: false,
//       dotColor: 'blue'
//     },
//     {
//       id: 9,
//       title: 'Revised Academic Calendar for AY 2025–26 Released',
//       category: 'Academic',
//       date: 'May 28, 2025',
//       isUrgent: false,
//       dotColor: 'green'
//     },
//     {
//       id: 10,
//       title: 'January 2025 Examination Results Declared',
//       category: 'Results',
//       date: 'May 20, 2025',
//       isUrgent: false,
//       dotColor: 'purple'
//     }
//   ];

//   // Filtering Logic
//   const filteredAnnouncements = announcementsData.filter((item) => {
//     const matchesSearch = item.title.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesCategory = activeCategory === 'All' || item.category === activeCategory;
//     return matchesSearch && matchesCategory;
//   });

//   return (
//       <>
//          <Navbar />
//     <div className="announcements-page-wrapper">
      
//       {/* 1. Header Hero Banner */}
//       <section className="announcements-hero-banner">
//         <div className="banner-inner-container">
//           <nav className="breadcrumb-nav">
//             <Link to="/" className="breadcrumb-link">Home</Link> / <span>Announcements</span>
//           </nav>
//           <h1>Announcements &amp; News</h1>
//           <p>Stay updated with the latest news, exam notifications, and academic calendar updates.</p>
//         </div>
//       </section>

//       {/* 2. Continuous Scrolling Yellow Ticker Banner */}
//       <div className="ticker-strip-wrapper">
//         <div className="ticker-track">
//           <span className="ticker-item">📢 Admissions Open – Apply by September 30, 2025</span>
//           <span className="ticker-dot">•</span>
//           <span className="ticker-item">🎓 Results Published – Check Student Portal</span>
//           <span className="ticker-dot">•</span>
//           <span className="ticker-item">📝 Assignment Last Date: July 31, 2025</span>
//           <span className="ticker-dot">•</span>
//           {/* Duplicated for seamless infinite looping */}
//           <span className="ticker-item">📢 Admissions Open – Apply by September 30, 2025</span>
//           <span className="ticker-dot">•</span>
//           <span className="ticker-item">🎓 Results Published – Check Student Portal</span>
//           <span className="ticker-dot">•</span>
//           <span className="ticker-item">📝 Assignment Last Date: July 31, 2025</span>
//         </div>
//       </div>

//       {/* 3. Controls Bar: Search & Category Filter Pills */}
//       <section className="announcements-controls-section">
//         <div className="announcements-container">
          
//           <div className="control-bar-flex">
//             {/* Search Input */}
//             <div className="search-input-box">
//               <span className="search-icon">🔍</span>
//               <input
//                 type="text"
//                 placeholder="Search announcements..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>

//             {/* Category Filter Pills */}
//             <div className="category-pills-row">
//               {categories.map((cat) => (
//                 <button
//                   key={cat}
//                   className={`filter-pill ${activeCategory === cat ? 'active-pill' : ''}`}
//                   onClick={() => setActiveCategory(cat)}
//                 >
//                   {cat}
//                 </button>
//               ))}
//             </div>
//           </div>

//         </div>
//       </section>

//       {/* 4. Announcements Cards List */}
//       <section className="announcements-list-section">
//         <div className="announcements-container">
          
//           {filteredAnnouncements.length > 0 ? (
//             <div className="announcements-cards-stack">
//               {filteredAnnouncements.map((item) => (
//                 <div key={item.id} className="announcement-card-row">
                  
//                   <div className="card-left-content">
//                     <span className={`status-dot dot-${item.dotColor}`}></span>
//                     <span className={`category-tag tag-${item.category.toLowerCase()}`}>
//                       {item.category}
//                     </span>
//                     <span className="date-info">
//                       <span className="cal-icon">📅</span> {item.date}
//                     </span>
//                     {item.isUrgent && (
//                       <span className="urgent-badge">URGENT</span>
//                     )}
//                     <h3 className="announcement-title">{item.title}</h3>
//                   </div>

//                   <div className="card-right-arrow">
//                     <span>→</span>
//                   </div>

//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="no-results-box">
//               <h3>No announcements found.</h3>
//               <p>Try searching for a different keyword or reset category filters.</p>
//             </div>
//           )}

//         </div>
//       </section>

//     </div>
//      <FooterSection/>
//             </>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AnnouncementsPage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

const API_URL = 'https://metapi.emedhatechnologies.com/api/courses/api/announcements';

export default function AnnouncementsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const [announcementsData, setAnnouncementsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const categories = [
    'All',
    'Admission',
    'Results',
    'Exam',
    'Assignment',
    'Event',
    'Holiday',
    'Notice',
    'Academic',
  ];

  // Fetch API Announcements
  const fetchAnnouncements = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setAnnouncementsData(data);
    } catch (err) {
      console.error('Error fetching announcements:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // Helper function to convert DB date strings to readable format (e.g., "July 15, 2025")
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  };

  // Helper function to map category to UI dot color CSS class
  const getDotColor = (category) => {
    if (!category) return 'red';
    switch (category.toLowerCase()) {
      case 'admission':
      case 'results':
      case 'assignment':
        return 'red';
      case 'holiday':
      case 'event':
      case 'academic':
        return 'green';
      case 'exam':
        return 'purple';
      case 'notice':
        return 'yellow';
      default:
        return 'blue';
    }
  };

  // Filtering Logic (Applies live on API fetched data)
  const filteredAnnouncements = announcementsData.filter((item) => {
    const titleMatch = item.title ? item.title.toLowerCase().includes(searchTerm.toLowerCase()) : false;
    const categoryMatch = activeCategory === 'All' || (item.category && item.category.toLowerCase() === activeCategory.toLowerCase());
    return titleMatch && categoryMatch;
  });

  return (
    <>
      <Navbar />
      <div className="announcements-page-wrapper">
        
        {/* 1. Header Hero Banner */}
        <section className="announcements-hero-banner">
          <div className="banner-inner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>Announcements</span>
            </nav>
            <h1>Announcements &amp; News</h1>
            <p>Stay updated with the latest news, exam notifications, and academic calendar updates.</p>
          </div>
        </section>

        {/* 2. Continuous Scrolling Yellow Ticker Banner */}
        <div className="ticker-strip-wrapper">
          <div className="ticker-track">
            <span className="ticker-item">📢 Admissions Open – Apply by September 30, 2025</span>
            <span className="ticker-dot">•</span>
            <span className="ticker-item">🎓 Results Published – Check Student Portal</span>
            <span className="ticker-dot">•</span>
            <span className="ticker-item">📝 Assignment Last Date: July 31, 2025</span>
            <span className="ticker-dot">•</span>
            {/* Duplicated for seamless infinite looping */}
            <span className="ticker-item">📢 Admissions Open – Apply by September 30, 2025</span>
            <span className="ticker-dot">•</span>
            <span className="ticker-item">🎓 Results Published – Check Student Portal</span>
            <span className="ticker-dot">•</span>
            <span className="ticker-item">📝 Assignment Last Date: July 31, 2025</span>
          </div>
        </div>

        {/* 3. Controls Bar: Search & Category Filter Pills */}
        <section className="announcements-controls-section">
          <div className="announcements-container">
            <div className="control-bar-flex">
              
              {/* Search Input */}
              <div className="search-input-box">
                <span className="search-icon">🔍</span>
                <input
                  type="text"
                  placeholder="Search announcements..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Category Filter Pills */}
              <div className="category-pills-row">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`filter-pill ${activeCategory === cat ? 'active-pill' : ''}`}
                    onClick={() => setActiveCategory(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>

            </div>
          </div>
        </section>

        {/* 4. Announcements Cards List */}
        <section className="announcements-list-section">
          <div className="announcements-container">
            {loading ? (
              <div className="no-results-box">
                <h3>Loading announcements...</h3>
              </div>
            ) : filteredAnnouncements.length > 0 ? (
              <div className="announcements-cards-stack">
                {filteredAnnouncements.map((item) => {
                  const dotColor = getDotColor(item.category);
                  const isUrgentOrNew = Boolean(item.is_new || item.isUrgent);

                  return (
                    <div key={item.id} className="announcement-card-row">
                      <div className="card-left-content">
                        <span className={`status-dot dot-${dotColor}`}></span>
                        <span className={`category-tag tag-${item.category ? item.category.toLowerCase() : 'default'}`}>
                          {item.category}
                        </span>
                        <span className="date-info">
                          <span className="cal-icon">📅</span> {formatDate(item.date_posted || item.date)}
                        </span>
                        {isUrgentOrNew && (
                          <span className="urgent-badge">URGENT</span>
                        )}
                        <h3 className="announcement-title">{item.title}</h3>
                      </div>

                      <div className="card-right-arrow">
                        <span>→</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="no-results-box">
                <h3>No announcements found.</h3>
                <p>Try searching for a different keyword or reset category filters.</p>
              </div>
            )}
          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}